import React, { useMemo, useState } from 'react';
import { ExpiredSessionNotice } from '../shared/activity-viewer';

const API_URL = process.env.REACT_APP_API_URL || 'https://api.monalerte.app';
const text = { margin: 0, color: '#A0A0A0', lineHeight: 1.5 };

/**
 * Lien de secours d'un rendez-vous (/rdv-secours/<identifiant>#k=…), confié par
 * un participant à une personne de confiance. Il ne montre rien du rendez-vous :
 * il explique quoi en faire, et permet de demander une relecture à MonAlerte.
 * Le secret (#k=…) ne quitte pas ce navigateur.
 */
export default function RendezVousBackupPage() {
  const rdvId = useMemo(() => decodeURIComponent(window.location.pathname.split('/')[2] || ''), []);
  const [copied, setCopied] = useState(false);
  const copy = () => navigator.clipboard?.writeText(window.location.href).then(() => setCopied(true)).catch(() => {});

  return (
    <ExpiredSessionNotice
      apiUrl={API_URL}
      requestPath={`/api/rendez-vous/${encodeURIComponent(rdvId)}/investigation-request`}
      title="Lien de secours d’un rendez-vous MonAlerte"
      intro={(
        <>
          <p style={text}>
            Une personne vous a confié ce lien avant un rendez-vous. <strong>Si elle est en danger ou injoignable, appelez
            d’abord le 17 ou le 112.</strong>
          </p>
          <p style={text}>
            Ce lien est la seule clé de ce rendez-vous : avec lui, la police ou l’équipe MonAlerte peuvent relire ce qui
            s’est passé (positions, messages, photos, vidéos), avec la preuve que rien n’a été modifié. Sans lui, personne
            ne peut le lire, pas même MonAlerte. Ne le diffusez pas : transmettez-le seulement aux enquêteurs.
          </p>
        </>
      )}
    >
      <button type="button" onClick={copy}
        style={{ padding: 12, borderRadius: 10, border: '1px solid #FACC15', background: 'transparent', color: '#FACC15', fontWeight: 700, cursor: 'pointer' }}>
        {copied ? 'Lien copié' : 'Copier le lien pour le transmettre'}
      </button>
    </ExpiredSessionNotice>
  );
}
